var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BranchPostIndexReport',{attrs:{"items":_vm.items,"pfilters":this.$route.params.filters,"area-id":Number(this.$route.params.areaId)},on:{"updated":_vm.onUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }